import styled from 'styled-components'

export const HeaderElem = styled.header`
  margin: 100px 0 30px;
  min-height: 80px;
  width: 65%;
`

export const Title = styled.header`
  font-size: 40px;
  line-height: 30px;
  color: ${(props) => props.theme.colors.settingsHeader.title};
  font-weight: 500;
  text-transform: uppercase;
  margin-bottom: 20px;
`
export const Description = styled.p`
  font-size: 20px;
  line-height: 1.5;
  white-space: pre-line;
  margin-bottom: 50px;
  color: ${(props) => props.theme.colors.settingsHeader.text};
`
